/* eslint-disable no-unused-vars,no-debugger */
import axios from 'axios'
import resampleRoute from '@/tools/fuel-plan/resample-route';
import calculateInsertPointIndex from '@/tools/fuel-plan/insert-waypoints';
import api from "@/api/fuel-plan";
import { getActiveRoute } from './index'
import tripPlanService from './service'

const Service = new tripPlanService()
const CancelToken = axios.CancelToken
export default {
  state: {
    fuelPlanSettings: {
      network: ['Truck Stops', 'TA', 'Petro', 'Loves', 'AMbest', 'Pilot', 'Flying J', 'KwikTrip/KwikStar', 'Fuel'],
      startTank: '200', // 初始油量
      tankCapacity: '200', // 油箱容量
      mpg: '6', // 每加仑英里油耗
      gallons: '100' // 最低燃油
    },
    selectedFuelStation: null, // 选中的
    fuelPlanAxiosToken: {}
  },
  mutations: {
    SET_FUEL_PLAN_RESULT(state, data) {
      let route = state.calculateRouteResult.list.find(item => item.id === data.route.id)
      route['fuelPlanResult'] = Object.assign({}, data.result, { code: data.code })
      if (data.code === 500) {
        route['routeType'] = 'fuelSuccessful'
        if (route.isActive) {
          state.activeRoute = getActiveRoute(route)
        }
      }
    },
    SET_FUEL_PLAN_WAYPOINTS(state, data) {
      let route = state.calculateRouteResult.list.find(item => item.id === data.route.id)
      route['fuelPlanWaypoints'] = data.fuelWaypoints
      route['routeType'] = 'fuelSuccessful'
      if (route.isActive) {
        state.activeRoute = getActiveRoute(route)
      }
    },
    SET_FUEL_PLAN_SETTINGS(state, settings) {
      state.fuelPlanSettings = settings
    },
    SET_FUEL_PLAN_STATUS(state, data) {
      let route = state.calculateRouteResult.list.find(item => item.id === data.route.id)
      route['routeType'] = data.status
      if (route.isActive) {
        state.activeRoute = getActiveRoute(route)
      }
    },
    SET_SELECTED_FUEL_STATION(state, poi) {
      state.selectedFuelStation = poi ? Object.assign({}, poi) : null
    },
    SET_FUEL_PLAN_AXIOS_TOKEN(state, token) {
      state.fuelPlanAxiosToken = token
    },
    INIT_FUEL_PLAN(state) {
      state.fuelPlanAxiosToken = {}
      state.selectedFuelStation = null
    }
  },
  actions: {
    insertFuelStation({ commit }, fuelPlanRoute) {
      let waypoints = fuelPlanRoute.waypointList.map((item, index) => {
        item = Object.assign({}, item)
        if (item.stopPointType === 'origin') {
          item.arrival_volume = fuelPlanRoute.fuelPlanResult.initial_volume
        } else if (item.stopPointType === 'target') {
          item.arrival_volume = fuelPlanRoute.fuelPlanResult.final_arrival_volume
        }
        return item
      })
      let viaWaypoints = []
      const fuelWaypoints = fuelPlanRoute.fuelPlanResult.poi_list
      waypoints.map(item => {
        viaWaypoints.push({...item, via: []}, ...(item.via || []))
      })
      fuelWaypoints.forEach(fuelWP => {
        const index = calculateInsertPointIndex(viaWaypoints, fuelWP)
        viaWaypoints.splice(index, 0, fuelWP);
      })
      let resultList = []
      let _v = []
      viaWaypoints.map(item => {
        if (item.stopPointType === 'polylinePointDragDone') {
          _v.push(item)
        } else {
          let lastPoint = resultList[resultList.length - 1]
          if (lastPoint && _v.length) {
            let lastViaLegth = (lastPoint.via || []).length
            let newVia = _v.map(v => ({ ...v, dragInfo: { waypointIndex: Math.max(0, resultList.length - 1), viaIndex: lastViaLegth++ } }))
            lastPoint.via = [...(lastPoint.via || []), ...newVia]
          }
          resultList.push(item)
          _v = []
        }
      })
      commit('SET_FUEL_PLAN_WAYPOINTS', {
        route: fuelPlanRoute,
        fuelWaypoints: resultList
      })
    },
    calcFuelPlan({ commit, dispatch, state }, fuelOptions) {
      if (!fuelOptions.route) return null
      let routeId = fuelOptions.route.id
      // 取消不需要的请求
      let invalidRequest = [state.fuelPlanAxiosToken[routeId]].filter(item => !!item)
      invalidRequest.map(item => item.cancel('cancel request'))

      // 创建新的请求token
      let source = CancelToken.source()
      commit('SET_FUEL_PLAN_AXIOS_TOKEN', Object.assign({}, state.fuelPlanAxiosToken, { [routeId]: source }))

      let fuelPlanSettings = state.fuelPlanSettings
      fuelOptions.options = {
        "startFuel": Number(fuelPlanSettings.startTank),
        "milesPerGallon": Number(fuelPlanSettings.mpg),
        "tankCapacity": Number(fuelPlanSettings.tankCapacity),
        "minFuelCapacity": Number(fuelPlanSettings.gallons),
        "fuelChains": fuelPlanSettings.network
      }
      const data = fuelOptions.options

      const pointDistances = resampleRoute(fuelOptions.route.shape)
      Object.assign(data, {
        tripId: "01616809138974",
        fuelPlanId: "016168091389741616810434102",
        pointDistances: pointDistances
      })
      commit('SET_FUEL_PLAN_STATUS', {
        route: fuelOptions.route,
        status: 'fuelLoading'
      })
      api.getFuelPlan(data, source.token).then(({ res }) => {

        if (res.data.code === 500) {
          let message = res.data.message
          if (message.indexOf('Cannot reach first poi') !== -1) {
            message = 'Cannot reach first poi'
          }
          commit('SET_FUEL_PLAN_RESULT', {
            route: fuelOptions.route,
            result: { message },
            code: 500
          })
        } else {
          const fuelPlan = res.data.data
          fuelPlan.poi_list = fuelPlan.poi_list.filter( x => x.lat !== 0)
          fuelPlan.poi_list.forEach(x => {
            x.mappedPosition = {latitude: x.lat, longitude: x.lng}
            x.stopPointType = 'fuelStation'
            x.pointType = 'fuelStation'
            x.pointId = x.ident
            x.poiId = x.ident
            // 再次规划路线使用
            x.latitude = x.lat
            x.longitude = x.lng
            x.value = x.title
            x.id = `${x.lat}-${x.lng}`
            x.uniqueIdentifier = `${x.ident}-${x.lat}-${x.lng}-${Date.now()}`
            x.stopType = 'Fuel'
            x.pointInfo = {...x}
          })
          commit('SET_FUEL_PLAN_RESULT', {
            route: fuelOptions.route,
            result: fuelPlan,
            code: 200
          })
          dispatch('insertFuelStation', { ...fuelOptions.route, fuelPlanResult: fuelPlan })
        }
      }).catch(({ error }) => {
        console.log(error)
        if (!error || error.message !== 'cancel request') {
          commit('SET_FUEL_PLAN_STATUS', {
            route: fuelOptions.route,
            status: 'fuelError'
          })
        }
      }).finally(() => {
        // 删除请求token
        commit('SET_FUEL_PLAN_AXIOS_TOKEN', Object.assign({}, state.fuelPlanAxiosToken, { [routeId]: null }))
      })
    },
    calcAllFuelPlan({ state, dispatch }) {
      state.calculateRouteResult.list.map(item => {
        dispatch('calcFuelPlan', { route: item })
      })
    },
    updateFuelPlanSettings({ commit }, { settings=null, isSave=false }) {
      if (settings) {
        commit('SET_FUEL_PLAN_SETTINGS', settings)
      }
      if (isSave) {
        localStorage.setItem('fuelSetting', JSON.stringify(settings))
      }
    },
    updateSelectedFuelStation({ commit }, data) {
      commit('SET_SELECTED_FUEL_STATION', data)
    }
  }
}
